import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { SuccessResponse } from '@interfaces/central-monitoring';
import { ObservationDetailsDto, DatasetResponseDto } from '@interfaces-clean/observations.interface';
import {
    AddSubjectObservationModel,
    UpdateSubjectObservationModel,
    DeleteSubjectObservationModel,
    SubjectObservationBulkUpdateDto,
} from '@interfaces-clean/subject-monitoring/subject-observations';
import { getData, postData } from '@apis/rest-client';

const observationUrl = 'SubjectMonitoring/SubjectObservations';

const timeout = 30000;

const SubjectObservationsApi = {
    useSave: (studyRef: string, sessionId?: string) => {
        const queryParams = new URLSearchParams();
        if (sessionId !== undefined) {
            queryParams.append('sessionId', sessionId);
        }

        return useSWRMutation(
            `${observationUrl}/Add/${studyRef}?${queryParams}`,
            (url: string, { arg }: { arg: AddSubjectObservationModel }) => {
                return postData<AddSubjectObservationModel, SuccessResponse>(url, { arg, timeout });
            },
        );
    },
    useUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${observationUrl}/Update/${studyRef}`,
            (url: string, { arg }: { arg: UpdateSubjectObservationModel }) => {
                return postData<UpdateSubjectObservationModel, SuccessResponse>(url, { arg, timeout });
            },
        );
    },
    useDelete: (studyRef: string, sessionId?: string) => {
        const queryParams = new URLSearchParams();
        if (sessionId !== undefined) {
            queryParams.append('sessionId', sessionId);
        }

        return useSWRMutation(
            `${observationUrl}/Delete/${studyRef}?${queryParams}`,
            (url: string, { arg }: { arg: DeleteSubjectObservationModel }) => {
                return postData<DeleteSubjectObservationModel, boolean>(url, { arg, timeout });
            },
        );
    },
    useGetDetails: (studyRef: string, id: string) => {
        return useSWR(`${observationUrl}/${studyRef}/Details/${id}`, (url: string) => {
            return getData<ObservationDetailsDto>(url, { timeout: 30000 });
        });
    },
    useGetDatasets: (studyRef: string, observationId: string) => {
        return useSWR(`${observationUrl}/Datasets/${studyRef}/${observationId}`, (url: string) => {
            return getData<DatasetResponseDto[]>(url, { timeout: 30000 });
        });
    },
    useBulkUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${observationUrl}/BulkUpdate/${studyRef}`,
            (url: string, { arg }: { arg: SubjectObservationBulkUpdateDto }) => {
                return postData<SubjectObservationBulkUpdateDto, boolean>(url, { arg, timeout });
            },
        );
    },
};

export default SubjectObservationsApi;
